import { Suspense } from "react";
import { RouterProvider } from "react-router";
import {
  AppInitialLoaderProvider,
  StudioApolloProvider,
  StudioQueryClientProvider,
  ThemeProvider,
} from "@/providers";
import { appRouter } from "@/routes/AppRouter";
import { ErrorBoundary } from "@/presentation/components/shared/ErrorBoundary";

const App = () => {
  return (
    <AppInitialLoaderProvider>
      <ThemeProvider>
        <ErrorBoundary>
          <StudioApolloProvider>
            <StudioQueryClientProvider>
              <Suspense fallback={null}>
                <RouterProvider router={appRouter} />
              </Suspense>
            </StudioQueryClientProvider>
          </StudioApolloProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </AppInitialLoaderProvider>
  );
};

export default App;
